import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Service from './request.js'

import common from '../common/common'
import bll from '../common/bll'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import BaiduMap from 'vue-baidu-map'
import Lazyload from 'vue-lazyload'
import Directive from './utils/directive.js'
import MyCompontents from './components'
import Es6Promise from 'es6-promise'
import countly from '../common/countly'



/* 引入vant组件 */
import { NoticeBar, Button, Popup, DatetimePicker, RadioGroup, Radio, Checkbox, CheckboxGroup } from 'vant';
import 'vant/lib/index.css';
import './assets/sass/iconfont.css'



Es6Promise.polyfill()
Vue.config.productionTip = false
Vue.prototype._ = common._
Vue.prototype.countly = countly
Vue.prototype.bll = bll.bll
Vue.prototype.MessageBox = MintUI.MessageBox
Vue.prototype.Indicator = MintUI.Indicator
Vue.prototype.Toast = MintUI.Toast
Vue.use(MintUI)
Vue.use(Service)
Vue.use(Lazyload)
Vue.use(BaiduMap, { ak: 'XUI7drO7XvRjnvngnGAjm3sYawBl31bv' })
Vue.use(MyCompontents)
Vue.use(NoticeBar);
Vue.use(Button);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

// 自定义指令
Vue.use(Directive.BlurEven)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
